import style from "./apptopicbanner.module.scss";
import classNames from "classnames";
import FavouriteButton from "../FavouriteButton/FavouriteButton";
import useToast from "../../hooks/useToast";
import {useFindInPage} from "../../hooks/FindInPageHooks/useFindInPage";
import GuidelineChip from "../Guideline/GuidelineChip";

const DEFAULT_FAVOURITE_TOAST_DURATION = 3000;

const TopBarWeb = ({ topicTitle, topicUrl, guideline, topicDetails, bannerText }) => {
  const findInPage = useFindInPage();
  const iconFontSize = classNames("tg-icons-FontSize", "iconSize");
  const iconFindInPage = classNames("tg-icons-FindInPage", "iconSize");
  const iconShare = classNames("tg-icons-Share", "iconSize");
  const standardButtonStyle = classNames("size-14", style.button);
  const pageTocStyle = classNames("size-14", style.button);
  const toast = useToast();

  const triggerToast = (added) => {
    toast.triggerToast({
      type: "info",
      primaryMessage: added ? "Added to favourites" : "Removed from favourites",
      rightText: "<a href=\"/favourites\">View</a>",
      autoHideDuration: DEFAULT_FAVOURITE_TOAST_DURATION,
    });
  }

  return (
    <div className={style.topBarWeb}>
      <div className={style.header}>
        <div className={style.headline}>
          <h1>{bannerText}</h1>
        </div>
        <div className={style.chipContainer}>
          <GuidelineChip
            iconClassSuffix={topicDetails?.squareIconClass}
            linkText={topicDetails?.text}
            onClickProps={topicDetails?.onClickProps}
            showArrowIcon={false}
          />
        </div>
      </div>
      <div className={style.iconGroup}>
        <button
          type="button"
          className={pageTocStyle}
          aria-label="Find in page"
          onClick={findInPage.openModal}
        >
          <i className={iconFindInPage}></i>
        </button>
        <button
          type="button"
          className={standardButtonStyle}
          aria-label="Font Size Selector"
        >
          <i className={iconFontSize}></i>
        </button>
        <button
          type="button"
          className={standardButtonStyle}
          aria-label="Share"
        >
          <i className={iconShare}></i>
        </button>
        <FavouriteButton
          sectionTitle={topicTitle}
          sectionUrl={topicUrl}
          type="topic"
          topicSection={guideline}
          triggerToast={triggerToast}
          styling={standardButtonStyle}
        />
      </div>
    </div>
  );
};

export default TopBarWeb;